<div class="row">
    <div class="col-md-12 col-xs-12 vh-100">
            <ag-grid-angular
            class="ag-theme-alpine"
            [gridOptions]="gridOptions"
            (gridReady)="gridSetting($event)"
            [columnDefs]="columnDefs"
            [rowData]="activeTracker"
            [domLayout]="'autoHeight'"
            [pagination]= "true"
            [paginationPageSize]="10"
            [paginationPageSizeSelector]="[10,20,30]"
            [enableCellTextSelection]="true">
            </ag-grid-angular>
    </div>
</div>